import $ from 'jquery';
import { jarallax, jarallaxElement } from 'jarallax';
import ymaps from 'ymaps';

import init from '../helpers/init';
import FullPage from '../widgets/FullPage';
import Why from '../widgets/Why';
import Works from '../widgets/Works';
import Map from '../widgets/Map';
import ServicesSlider from '../widgets/ServicesSlider';
import Advantages from '../widgets/Advantages';
import Services from '../widgets/Services';
import CallBack from '../widgets/CallBack';
import ShowIcon from '../widgets/ShowIcon';
import mountAudioEqualizer from '../widgets/AudioEqualizer';

const PAGES = new Set(['/', '/index.html', '/second.html', '/service.html', '/404.html']);

let currentPath = normalize(window.location.pathname);
let navToken = 0;
let jarallaxReady = false;

function normalize(pathname) {
  if (pathname === '/index.html') return '/';
  return pathname;
}

function isSitePage(pathname) {
  return PAGES.has(pathname) || PAGES.has(normalize(pathname));
}

export function unmountPage() {
  document.querySelectorAll('.swiper-container').forEach((el) => {
    if (el.swiper && el.swiper.destroy) el.swiper.destroy(true, true);
  });

  document.querySelectorAll('.js-map').forEach((el) => {
    if (el._kriosMap && el._kriosMap.destroy) {
      el._kriosMap.destroy();
      el._kriosMap = null;
    }
  });

  const parallax = document.querySelectorAll('.js-parallax');
  if (parallax.length) {
    try { jarallax(parallax, 'destroy'); } catch (e) { /* ещё не был запущен */ }
  }

  if ($.fn.fullpage && typeof $.fn.fullpage.destroy === 'function') {
    try { $.fn.fullpage.destroy('all'); } catch (e) { /* на услуге fullPage нет */ }
  }

  $(window).off('resize.kriosFullPage');
}

export function mountPage() {
  init('.js-full-page', FullPage);
  init('.js-why', Why);
  init('.js-works', Works, 'Works');
  init('.js-services-slider', ServicesSlider);
  init('.js-advantages', Advantages);
  init('.js-services', Services);
  init('.js-callback', CallBack, 'CallBack');
  ymaps.ready(() => {
    $('.js-map').each((_, el) => {
      if (el._kriosMap) return;
      init(el, Map);
    });
  });

  const parallax = document.querySelectorAll('.js-parallax');
  if (parallax.length) {
    if (!jarallaxReady) {
      jarallaxElement();
      jarallaxReady = true;
    }
    jarallax(parallax, {
      disableParallax: /iPad|iPhone|iPod|Android/,
      disableVideo: /iPad|iPhone|iPod|Android/
    });
  }

  ShowIcon.observeSceneIcons();
  mountAudioEqualizer();
}

function applyDocument(doc) {
  const html = document.documentElement;
  const keep = ['_loaded', '_loaded-before'].filter((name) => html.classList.contains(name));
  html.className = doc.documentElement.className;
  keep.forEach((name) => html.classList.add(name));

  const title = doc.querySelector('title');
  if (title) document.title = title.textContent;

  const newHeader = doc.querySelector('.page__header');
  const oldHeader = document.querySelector('.page__header');
  if (newHeader && oldHeader) oldHeader.outerHTML = newHeader.outerHTML;

  const newMain = doc.querySelector('.page__main');
  const oldMain = document.querySelector('.page__main');
  if (newMain && oldMain) oldMain.outerHTML = newMain.outerHTML;

  const newMenu = doc.querySelector('.page__menu');
  const oldMenu = document.querySelector('.page__menu');
  if (newMenu && oldMenu) oldMenu.className = newMenu.className;
}

function closePopup() {
  const popup = document.querySelector('[data-remodal-id="popup"]');
  if (!popup) return;
  try { $(popup).remodal().close(); } catch (e) { /* попап ещё не открывали */ }
}

async function go(url, push) {
  const token = ++navToken;
  let response;
  try {
    response = await fetch(url.pathname + url.search, { credentials: 'same-origin' });
  } catch (e) {
    window.location.href = url.href;
    return;
  }
  if (!response.ok) {
    window.location.href = url.href;
    return;
  }

  const html = await response.text();
  if (token !== navToken) return;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  if (!doc.querySelector('.page__main')) {
    window.location.href = url.href;
    return;
  }

  closePopup();
  unmountPage();
  applyDocument(doc);
  window.scrollTo(0, 0);

  const next = url.pathname + url.search + url.hash;
  if (push) history.pushState({ krios: 1 }, '', next);
  currentPath = normalize(url.pathname);
  mountPage();
}

function linkUrl(anchor) {
  if (!anchor || anchor.target && anchor.target !== '_self') return null;
  if (anchor.hasAttribute('download')) return null;
  if (anchor.classList.contains('js-popup-open')) return null;

  let url;
  try { url = new URL(anchor.getAttribute('href'), window.location.href); } catch (e) { return null; }
  if (url.origin !== window.location.origin) return null;
  if (!isSitePage(url.pathname)) return null;
  if (normalize(url.pathname) === currentPath) return null;
  return url;
}

export function bindPageLinks() {
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    const url = linkUrl(anchor);
    if (!url) return;
    event.preventDefault();
    go(url, true);
  });

  window.addEventListener('popstate', () => {
    const url = new URL(window.location.href);
    if (normalize(url.pathname) === currentPath) return;
    go(url, false);
  });
}
